export default __webpack_public_path__ + "static/char-s-09-kr-dfbe38598131af52a9df90697d89f8bf.png";